
import { types, actions } from './requests'
export const GETSTDARTICLELIST_TYPES = {
    ...types('GETSTDARTICLELIST'),
}
export const GETSTDARTICLELIST_ACTIONS = {
    ...actions('GETSTDARTICLELIST'),
}